import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Instagram } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Hemos eliminado { name: 'Portfolio', path: '/portfolio' } de esta lista
  const navLinks = [
    { name: 'About', path: '/about' },
    { name: 'Bridal', path: '/bridal' },
    { name: 'Editorial', path: '/editorial' },
    { name: 'Social', path: '/social' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-white/98 backdrop-blur-sm border-b border-black/5' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-12 lg:px-20">
        <div className="flex items-center justify-between h-28 lg:h-32">
          {/* Logo */}
          <Link to="/" className="group">
            <div className="flex items-center gap-4">
              <span className="text-lg lg:text-xl font-light tracking-[0.25em] text-black group-hover:opacity-60 transition-opacity">
                LAURA GONZALEZ
              </span>
              <span className="text-lg lg:text-xl font-extralight text-black">|</span>
              <span className="text-[10px] lg:text-[11px] tracking-[0.35em] text-black/70 uppercase font-light">
                HAIR & MAKEUP ARTIST
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-12">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-[9px] tracking-[2px] uppercase font-light transition-opacity hover:opacity-60 ${
                  location.pathname === link.path ? 'opacity-60' : 'opacity-100'
                }`}
                style={{ letterSpacing: '2px' }}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://www.instagram.com/laugonzalez.mua?igsh=YmJ3eW1pcnZtd3V5&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-black hover:opacity-60 transition-opacity"
              aria-label="Instagram"
            >
              <Instagram size={16} strokeWidth={1} />
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-black hover:opacity-60"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={20} strokeWidth={1} /> : <Menu size={20} strokeWidth={1} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-black/5">
          <nav className="flex flex-col px-12 py-10 gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`text-[10px] tracking-[2px] uppercase font-light transition-opacity hover:opacity-60 ${
                  location.pathname === link.path ? 'opacity-60' : 'opacity-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="https://www.instagram.com/laugonzalez.mua?igsh=YmJ3eW1pcnZtd3V5&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 text-[10px] tracking-[2px] uppercase font-light text-black hover:opacity-60 transition-opacity"
            >
              <Instagram size={16} strokeWidth={1} />
              Instagram
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
